<template>
  <v-select
    :items="items"
    v-bind="$attrs"
    :menu-props="menuProps"
    :loading="loading"
    v-model="form"
    hide-selected
  >
    <template #prepend-item>
      <v-text-field
        single-line
        dense
        autofocus
        v-model="params.search"
        clearable
        outlined
        hide-details
        class="pa-2"
      ></v-text-field>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    value: {},
    api: { type: Object, required: true },
    defaultParams: { type: Object, default: () => ({}) },
  },
  data: () => ({
    items: [],
    p_value: null,
    loading: false,
    params: { search: null, limit: 10 },
    menuProps: { bottom: true, offsetY: true },
  }),
  computed: {
    form: {
      get() {
        return this.p_value || this.value
      },
      set(value) {
        this.p_value = value
        this.$emit('input', value)
      },
    },
  },
  watch: {
    params: {
      handler(value) {
        this.getData()
      },
      deep: true,
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.items = this.p_value || []
      this.loading = true
      try {
        let res = await this.api.list({ ...this.defaultParams, ...this.params })
        this.items = this.items.concat(res.data)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped></style>
